import { client } from '.';

export const getRole = async () => {
  const { data } = await client.get('/api/v1/permissions/access');
  return data;
};
